export const MIN_NUMBER_OF_ROWS_TO_DISPLAY = 5;
